export const pageActionsTypes = {
  CURRENT_PAGE: 'CURRENT_PAGE',
  CURRENT_TAB: 'CURRENT_TAB',
  CHILD_CURRENT_PAGE: 'CHILD_CURRENT_PAGE',
  CHILD_CURRENT_TAB: 'CHILD_CURRENT_TAB',
}
